import { ColumnSelectionsModel } from "../../models";

export const CallCenterActivityColumns: ColumnSelectionsModel[] = [
    { name: 'Name', propertyName: 'Name', isEnabled: true },
    { name: 'Email', propertyName: 'Email', isEnabled: true },
    { name: 'Platform Type', propertyName: 'PlatformType', isEnabled: true },
    { name: 'Activity', propertyName: 'Action', isEnabled: true },
    { name: 'Device', propertyName: 'Device', isEnabled: true },
    { name: 'Date Time', propertyName: 'DateTime', isEnabled: true },
]